import i18next from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import discEn from "./utils/translations/en/disc.json";
import discEs from "./utils/translations/es/disc.json";

const apiKey = "qAZxS3_Q_q53iKFx_HOkgA";
const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",

    ns: ["default"],
    defaultNS: "default",

    supportedLngs: ["en","es","ru", "ja", "zh"],
    keySeparator: false,
    // resources: {
    //     en: {
    //         translation: {
    //             ...discEn
    //         }
    //     },
    //     es: {
    //         translation: {
    //             ...discEs
    //         }
    //     }
    // },
    backend: {
      loadPath: loadPath
    }
  })


  export default i18next;